// giusp.com grn@giusp.com

import { pass, neutral, fail, styleAsIsValid, styleAsIsInvalid } from "./service_commons.js";

let inputElementName_start = "serviceInput_start";
let inputElementName_end = "serviceInput_end";
let inputElementName_step = "serviceInput_step";

function precheck_inputElement_start(inputElement) {
    let n = inputElement.value;

    if ((n === "" || n == null) || (!/^-?[0-9]+$/.test(n))) {
        fail("first");
        return false;
    }

    n = parseInt(n);

    if (n < -Math.pow(10, 18) || n > Math.pow(10, 18)) {
        fail("first");
        return false;
    }

    pass("first");
    return true;
}

function precheck_inputElement_end(inputElement) {
    let n = inputElement.value;

    if ((n === "" || n == null) || (!/^-?[0-9]+$/.test(n))) {
        fail("second");
        return false;
    }

    n = parseInt(n);

    if (n < -Math.pow(10, 18) || n > Math.pow(10, 18)) {
        fail("second");
        return false;
    }

    pass("second");
    return true;
}

function precheck_inputElement_step(inputElement) {
    let n = inputElement.value;

    if ((n === "" || n == null) || (!/^-?[0-9]+$/.test(n))) {
        fail("third");
        return false;
    }

    n = parseInt(n);

    if (n == 0) {
        fail("third");
        return false;
    }

    if (n < -Math.pow(10, 18) || n > Math.pow(10, 18)) {
        fail("third");
        return false;
    }

    pass("third");
    return true;
}

function precheck_total() {
    if (!(precheck_inputElement_start(document.getElementById(inputElementName_start)) &&
        precheck_inputElement_end(document.getElementById(inputElementName_end)) &&
        precheck_inputElement_step(document.getElementById(inputElementName_step)))) {
        neutral("fourth");
        return false;
    }

    let start = parseInt(document.getElementById(inputElementName_start).value);
    let end = parseInt(document.getElementById(inputElementName_end).value);
    let step = parseInt(document.getElementById(inputElementName_step).value);

    if ((start < end && step < 0) || (start > end && step > 0)) {
        fail("fourth");
        return false;
    }
    if (Math.abs(Math.floor((end - start) / step)) > Math.pow(10, 6)) {
        fail("fourth");
        return false;
    }

    pass("fourth");
    return true;
}

function precheckStyle_inputElement_start(inputElement) {
    if (precheck_inputElement_start(inputElement)) {
        styleAsIsValid(inputElement);
    } else {
        styleAsIsInvalid(inputElement);
    }
}

document.getElementById(inputElementName_start).oninput = function () {
    precheckStyle_inputElement_start(this);
    precheckStyle_total();
};

function precheckStyle_inputElement_end(inputElement) {
    if (precheck_inputElement_end(inputElement)) {
        styleAsIsValid(inputElement);
    } else {
        styleAsIsInvalid(inputElement);
    }
}

document.getElementById(inputElementName_end).oninput = function () {
    precheckStyle_inputElement_end(this);
    precheckStyle_total();
};

function precheckStyle_inputElement_step(inputElement) {
    if (precheck_inputElement_step(inputElement)) {
        styleAsIsValid(inputElement);
    } else {
        styleAsIsInvalid(inputElement);
    }
}

document.getElementById(inputElementName_step).oninput = function () {
    precheckStyle_inputElement_step(this);
    precheckStyle_total();
}

function precheckStyle_total() {
    if (precheck_total()) {
        document.getElementById("serviceFormSendButton").removeAttribute("disabled");
    }
    else {
        document.getElementById("serviceFormSendButton").setAttribute("disabled",
            "disabled");
    }
}

window.onload = function () {
    precheck_inputElement_start(document.getElementById(inputElementName_start));
    precheck_inputElement_end(document.getElementById(inputElementName_end));
    precheck_inputElement_step(document.getElementById(inputElementName_step));
    let res = precheck_total();

    if (res) {
        document.getElementById("serviceFormSendButton").removeAttribute("disabled");
    } else {
        document.getElementById("serviceFormSendButton").setAttribute("disabled",
            "disabled");
    }
};
